import React from 'react';
import { Tooltip } from 'antd';
import { SENTIMENT_ICONS } from '../Reviews/Label';
import { FrownOutlined, MehOutlined, SmileOutlined } from '@ant-design/icons';

interface SentimentProps {
  positive: number;
  neutral: number;
  negative: number;
  width?: number | string;
  height?: number;
}

export const SentimentBar = ({ positive, neutral, negative, width = 200, height = 7 }: SentimentProps) => {
  // Calculamos los puntos de corte para las líneas verticales
  const p1 = positive;
  const p2 = positive + neutral;

  const resolvedWidth = typeof width === 'number' ? `${width}px` : width;

  const barStyle: React.CSSProperties = {
    width: resolvedWidth,
    height: `${height}px`,
    borderRadius: '6px',
    // linear-gradient hacia la derecha (to right) crea las divisiones verticales
    background: `linear-gradient(to right, 
      #52c41a 0% ${p1}%, 
      #faad14 ${p1}% ${p2}%, 
      #f5222d ${p2}% 100%
    )`,
    boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.2)',
    border: '1px solid #ddd',
    display: 'inline-block',
    overflow: 'hidden'
  };

  return (    
    <Tooltip title={
      <>
        <b>Sentimiento: </b>
        <div style={{color:'white', fontSize:'15px'}}><SmileOutlined style={{padding:'0px 4px'}}/> {positive}% positivas</div>
        <div style={{color:'white', fontSize:'15px'}}><MehOutlined style={{padding:'0px 4px'}}/> {neutral}% neutrales</div>
        <div style={{color:'white', fontSize:'16px'}}><FrownOutlined style={{padding:'0px 4px'}}/> {negative}% negativas</div>
        </>        
      }>
      <div style={barStyle}/>
    </Tooltip>    
  );
};